import React from 'react';
import Locale from '../domain/Locale';
import URL from '../domain/URL';
import WidgetFooter from '../components/WidgetFooter';
import { t, props } from 'tcomb-react';

@props({
  header: t.Obj,
  children: t.Any,
  locale: Locale,
  miniSiteURL: t.maybe(URL),
  footerImage: t.maybe(URL)
})
export default class WidgetLayout extends React.Component {

  getFooter() {
    if (!this.props.miniSiteURL && !this.props.footerImage) {
      return null;
    }
    return (
      <div id='containerFooter'>
        <WidgetFooter locale={this.props.locale} miniSiteURL={this.props.miniSiteURL} footerImage={this.props.footerImage} />
      </div>
    );
  }

  render() {
    return (
      <div>
        <div id='modal-container'></div>
        <div id='view' className='widget'>
          <div id='containerHeader'>
            {this.props.header}
          </div>
          <div id='containerBody'>
            <div className='container'>
              {this.props.children}
            </div>
          </div>
          {this.getFooter()}
          <div id='shield'></div>
          <div id='ajax'><div></div></div>
        </div>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/WidgetLayout.js
 **/